export const STATUS_SUCCESS = 'SUCCESS'
export const STATUS_ERROR = 'ERROR'

export const SUBSCRIPTION_TYPE = {
  CHANGELOG: 'changelog',
  NEWSLETTER: 'newsletter',
  ANNOUNCEMENTS: 'announcements',
};
